// SSO Azure (authorization code flow). Penukaran code -> token dilakukan di backend
// karena butuh client secret, FE hanya redirect dan meneruskan code.

const STATE_KEY = 'sso_state';
const NONCE_KEY = 'sso_nonce';

// .env tidak ikut repo, jadi beri fallback agar build di server tetap jalan.
// Client ID & tenant ID bukan rahasia; redirect URI mengikuti domain yang sedang dibuka.
const CLIENT_ID = process.env.VUE_APP_AZURE_CLIENT_ID || '42512c74-2c53-4902-92c2-40b5917540bc';
const TENANT_ID = process.env.VUE_APP_AZURE_TENANT_ID || '8b86a65e-3c3a-4406-8ac3-19a6b5cc52bc';
const redirectUri = () => process.env.VUE_APP_REDIRECT_URI || `${window.location.origin}/login/oauth2/code/azure`;

function randomString() {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}

export function redirectToMicrosoft() {
    const state = randomString();
    const nonce = randomString();
    sessionStorage.setItem(STATE_KEY, state);
    sessionStorage.setItem(NONCE_KEY, nonce);

    const params = new URLSearchParams({
        client_id: CLIENT_ID,
        response_type: 'code',
        response_mode: 'query',
        redirect_uri: redirectUri(),
        scope: 'openid profile email',
        prompt: 'select_account',
        state,
        nonce,
    });
    window.location.href = `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize?${params}`;
}

// Ambil nonce yang cocok dengan state dari callback, lalu hapus (sekali pakai)
export function consumeSsoState(state) {
    const savedState = sessionStorage.getItem(STATE_KEY);
    const nonce = sessionStorage.getItem(NONCE_KEY);
    sessionStorage.removeItem(STATE_KEY);
    sessionStorage.removeItem(NONCE_KEY);
    if (!state || !savedState || state !== savedState) return null;
    return nonce;
}
